import { getDatabase, ref, child, get } from "firebase/database";

export const getPortfolio = async () => {
    return get(child(ref(getDatabase()), `portfolioItems`)).then((snapshot) => {
        return snapshot.val()
    })
}